
import moment from 'moment';
import 'moment/locale/pt-br';

function formatDate(data) {
    if (!data)
        return '';
    return moment(data).format("DD/MM/yyyy HH:mm");
}

function formatDateLocal(data) {
    return moment(data).local().format("DD/MM/yyyy HH:mm");
}

function formatOlyDate(data) {
    if (!data)
        return '';
    return moment(data).format("DD/MM/yyyy");
}

function formatOlyTime(data) {
    if (!data)
        return '';
    return moment(data).format("HH:mm");
}

function compareOnlyDate(date1, date2) {
    const d1 =  formatOlyDate(date1);
    const d2 =  formatOlyDate(date2);
    return d1 === d2;
}

export default {
    formatDate,
    formatDateLocal,
    formatOlyDate,
    formatOlyTime,
    compareOnlyDate
};
